import { useTranslation } from "react-i18next";
import { usePageMeta } from "@/hooks/usePageMeta";
import styles from "./ContentPage.module.css";

const KEYS = [
  "cost",
  "funding",
  "privacy",
  "loginLost",
  "after",
  "data",
  "deletion",
  "countries",
] as const;

export function Faq() {
  const { t } = useTranslation();
  usePageMeta({
    title: t("pageMeta.faqTitle"),
    description: t("pageMeta.faqDescription"),
  });
  return (
    <article className={styles.page}>
      <div>
        <h1>{t("faq.title")}</h1>
        <p className={styles.lead}>{t("faq.lead")}</p>
      </div>
      <section>
        {KEYS.map((key) => (
          <div key={key} className={styles.qa}>
            <h2>{t(`faq.items.${key}.q`)}</h2>
            <p>{t(`faq.items.${key}.a`)}</p>
          </div>
        ))}
      </section>
    </article>
  );
}
